import { render, staticRenderFns } from "./vsc-select.vue?vue&type=template&id=3924b689&"
import script from "./vsc-select.vue?vue&type=script&lang=ts&"
export * from "./vsc-select.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports